import { IColumn, Modal } from '@ixyberfree/ixybercomponents';

import { GetReferences } from 'components/hmilib/api/Base';
import { ObjectReferences } from 'components/hmilib/interfaces';
import Tables from 'components/modules/trends/GroupTrend/Tables/Tables';
import React, { useEffect, useState } from 'react';
import { Loader } from '../Loader';
import style from './ref-obj-win.module.css';

interface IRefObjectsWindow {
    selectedData: any;
    closeCB?: () => void;
}

const tableHeader: IColumn[] = [
    { type: 'text', label: 'ObjectPath', width: '33%', idCol: 'ObjectPath' },
    { type: 'text', label: 'ObjectMethod', width: '33%', idCol: 'ObjectMethod' },
    { type: 'text', label: 'ReferencePath', width: '33%', idCol: 'ReferencePath' }
];

function RefObjectsWindow(props: IRefObjectsWindow) {
    const { selectedData, closeCB } = props;

    const [dataTable, setDataTable] = React.useState<ObjectReferences[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(false);
            try {
                const data = await GetReferences(selectedData.id);
                setDataTable(data);
            } catch (error) {
                console.error('Ошибка при получении ссылок:', error);
                setDataTable([]);
            } finally {
                setIsLoading(true);
            }
        };

        fetchData();
    }, []);

    return (
        <Modal
            className="modal-window"
            headerLabel="Ссылки"
            width={'30%'}
            onCloseClick={() => {
                closeCB && closeCB();
            }}>
            {isLoading ? (
                <div className={style.tableContainer}>
                    {dataTable.length > 0 ? (
                        <Tables
                            header={tableHeader}
                            data={dataTable}
                            actionSort={false}
                            actionFilter={false}
                            isFullRender={false}
                        />
                    ) : (
                        <p className={style.noLinks}>Ссылок нет</p>
                    )}
                </div>
            ) : (
                <Loader visible={true} />
            )}
        </Modal>
    );
}

export default RefObjectsWindow;
